import { render } from "./index.vue?vue&type=template&id=3dbee6e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3dbee6e4&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbee6e4"],['__file',"src/vab/components/VabErrorLog/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dbee6e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dbee6e4', __exports__)) {
    console.log('reload')
    api.reload('3dbee6e4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3dbee6e4&scoped=true", () => {
    console.log('re-render')
    api.rerender('3dbee6e4', render)
  })

}


export default __exports__